import { Component, OnInit, ViewEncapsulation } from '@angular/core';

@Component({
    selector: 'loyaltic-what-is-new',
    templateUrl: './what-is-new.component.html',
    styleUrls: ['./what-is-new.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class WhatIsNewComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
